/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.tableCharge", {
        options: {},

        _create: function () {
            this.wrap = this.element;

            this._eqRowTop();

            $(document).on("window-loaded", ()=>{
                this._reMinHeight()
            });

            $(document).on("window-resized", ()=>{
                this._reMinHeight()
            });

            if (
                this.wrap.hasClass("b-table-charge--day") ||
                this.wrap.hasClass("b-table-charge--night")
            ) {
                if(api.vars.windW > api.vars.scr.tablet){                    
                    this._addClicks();
                }              
            }
        },

        _eqRowTop() {
            var row = this.wrap
                .parents(".b-table-charge-row")
                .not(".js-row-init");
            if (row.length) {
                if (!row.hasClass("js-row-init")) {
                    row.addClass("js-row-init");
                    api.fn.equalMinHeights($(".b-table-charge__top", row));
                }
            }
        },

        _reMinHeight(){
            var row = this.wrap.parents(".b-table-charge-row")
            if (row.length) {
                $(".b-table-charge__top", row).removeAttr("style")
                api.fn.equalMinHeights($(".b-table-charge__top", row));
            }

        },

        _addClicks() {

            this.wrap.on("mouseover", (e) => {
                var parent = this.wrap.parents(".b-table-charge-bg");
                var cls = this.wrap.hasClass("b-table-charge--day")
                    ? "js-is-day"
                    : "js-is-night";
                

                if (parent.length) {
                    if(cls==="js-is-night"){
                        parent.removeClass("js-is-day") 
                    } else if(cls==="js-is-day"){
                        parent.removeClass("js-is-night") 
                    }
                    
                    parent.addClass(cls);
                }
            });

            this.wrap.on("mouseout", (e) => {
                var parent = this.wrap.parents(".b-table-charge-bg");

                parent.removeClass("js-is-day").removeClass("js-is-night") 
            })
        },
    });
})(jQuery);
